import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import { MapLayer } from '../MapLayer';
/**
 * OSM base tile layer served through the local mapcache proxy.
 * Always-on background — `base=true` so the LayerSwitcher groups it
 * with the other base layers.
 */
export class OsmBaseLayer extends MapLayer {
    getName() {
        return 'base_osm_layer';
    }
    getTitle() {
        return 'OpenStreetMap';
    }
    getOlLayer() {
        if (!this._layer) {
            this._layer = new TileLayer({
                source: new XYZ({
                    url: '/mapcache/openstreetmap/{z}/{x}/{y}.png'
                })
            });
            this._layer.set('base', true);
        }
        return this._layer;
    }
}
